import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const buyers = [{
  name: 'Martín',
  location: 'Buenos Aires',
  time: 'hace 2 minutos',
  plan: 'Plan Premium'
}, {
  name: 'Laura',
  location: 'Córdoba',
  time: 'hace 5 minutos',
  plan: 'Mega Pack'
}, {
  name: 'Diego',
  location: 'Rosario',
  time: 'hace 12 minutos',
  plan: 'Plan Premium'
}, {
  name: 'Sofía',
  location: 'Mendoza',
  time: 'hace 15 minutos',
  plan: 'Mega Pack'
}, {
  name: 'Alejandro',
  location: 'Tucumán',
  time: 'hace 22 minutos',
  plan: 'Plan Premium'
}, {
  name: 'Camila',
  location: 'Mar del Plata',
  time: 'hace 28 minutos',
  plan: 'Mega Pack'
}, {
  name: 'Facundo',
  location: 'Salta',
  time: 'hace 35 minutos',
  plan: 'Plan Premium'
}, {
  name: 'Valentina',
  location: 'La Plata',
  time: 'hace 42 minutos',
  plan: 'Mega Pack'
}, {
  name: 'Nicolás',
  location: 'Neuquén',
  time: 'hace 55 minutos',
  plan: 'Plan Premium'
}, {
  name: 'Florencia',
  location: 'San Juan',
  time: 'hace 1 hora',
  plan: 'Mega Pack'
}];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before showing the first popup
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    // Hide after 4 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 4000);
    return () => clearTimeout(hideTimer);
  }, [isVisible, currentIndex]);
  useEffect(() => {
    if (isVisible) return;
    // Show next person after 3 seconds of being hidden
    // Only start this timer if we've already shown at least one (handled by initial delay)
    // Actually, we need a flag to know if we've started the cycle.
    // The initial delay sets isVisible to true. Then it hides. Then this runs.
    const showTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % buyers.length);
      setIsVisible(true);
    }, 3000);
    return () => clearTimeout(showTimer);
  }, [isVisible]);
  const currentBuyer = buyers[currentIndex];
  const initials = currentBuyer.name.substring(0, 1);
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-177">
      <AnimatePresence data-id="element-178">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-white rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-gray-100 p-4 w-[300px] sm:w-[320px] flex items-start gap-3 pointer-events-auto" data-id="element-179">
            <div className="w-10 h-10 rounded-full bg-brand-100 text-brand-600 flex items-center justify-center font-bold text-lg flex-shrink-0" data-id="element-180">
              {initials}
            </div>
            <div className="flex-grow" data-id="element-181">
              <div className="flex items-center justify-between mb-0.5" data-id="element-182">
                <span className="font-bold text-gray-900 text-sm" data-id="element-183">
                  {currentBuyer.name}
                </span>
                <span className="text-xs text-gray-500" data-id="element-184">
                  {currentBuyer.time}
                </span>
              </div>
              <p className="text-xs text-gray-600 mb-1" data-id="element-185">
                de {currentBuyer.location}
              </p>
              <div className="flex items-center gap-1 text-xs font-medium text-gray-800" data-id="element-186">
                <CheckCircle2 className="w-3.5 h-3.5 text-green-500" data-id="element-187" />
                <span data-id="element-188">Compró el {currentBuyer.plan}</span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}